






































































import { switchDetailApi } from "@/api/storeManagement";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() listData!: any;
  tableData: any[] = [];
  switch_detail: any = {}; //机构配置开关
  created() {
    this.tableData = this.listData;
    switchDetailApi().then((res: any) => {
      if (res.error_code === 0) {
        this.switch_detail = res.data;
      }
    });
  }
}
